function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbbLogo = function SvgAbbLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 20
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.352 19.938h1.207c3.62-.18 6.152-3.028 6.152-6.422 0-1.153-.238-2.305-.781-3.211h-6.578ZM27.75 10.305h-6.035V20h6.035ZM34.566 9.695c-.605-.847-1.449-1.511-2.351-2 1.086-.785 1.808-2.058 1.808-3.453C34.023 1.88 32.153 0 29.801 0h-1.45v9.695ZM27.75 0h-6.035v9.695h6.035ZM44.64 20h1.208C49.465 19.816 52 16.969 52 13.574c0-1.148-.242-2.3-.785-3.21H44.64ZM44.035 10.305h-6.031V20h6.031ZM50.855 9.695c-.605-.847-1.449-1.511-2.355-2 1.086-.785 1.813-2.058 1.813-3.453C50.313 1.88 48.44 0 46.09 0h-1.45v9.695ZM44.035 0h-6.031v9.695h6.031ZM3.438 10.305 0 20h5.008l1.445-4.242h3.2v-5.453ZM9.652 0H7.06L3.62 9.695h6.031ZM10.254 15.758h3.2L14.901 20h5.004l-3.437-9.695h-6.215ZM16.29 9.695 12.847 0h-2.594v9.695Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ff000f",
      fillOpacity: 1
    }
  }));
};
export default SvgAbbLogo;